import { useEffect, useCallback } from 'react';
import { errorLogger, type ErrorDetails } from '../lib/errors';

export function useErrorHandler() {
  useEffect(() => {
    // Subscribe to error notifications
    const unsubscribe = errorLogger.addErrorListener((error: ErrorDetails) => {
      // Handle errors at the component level if needed
      console.debug('Error received in component:', error);
    });

    return () => unsubscribe();
  }, []);

  const handleError = useCallback((error: any, context?: Record<string, any>) => {
    if (error?.code === 'PGRST116') {
      // Handle specific Postgrest errors
      return; // Ignore "no rows returned" errors as they're often expected
    }

    errorLogger.logError({
      message: error?.message || 'An error occurred',
      code: error?.code,
      details: error?.details || error,
      context,
      handled: true,
    });
  }, []);

  return { handleError };
}